import {Component, OnDestroy, OnInit} from '@angular/core';
import {CircularStorageService} from "../../../financial-application/services/circular-storage.service";
import {DashboardService} from "../../service/dashboard.service";
import {Observable, Subscription} from "rxjs";
import {StpRegistrationService} from "../../../stp-registration/services/stp-registration.service";
import {StpRegistrationStorageService} from "../../../stp-registration/services/stp-registration-storage.service";
import {LoginResponse} from "../../../authentication/models/login-response.dto";
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { StpExpiryService, StpExpiryStatus } from '../../../../shared/services/stp-expiry.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, OnDestroy {

  enrolledPwdPerc: any;
  enrolledMargPerc: any;

  enrolledFemalePerc: any;
  enrolledMalePerc: any;
  enrolledOthersPerc: any;


  graduateddPerc: any;
  graduatedMalePerc: any;
  graduatedOthersPerc: any;
  graduatedFemalePerc: any;
  graduatedPwdPerc: any;
  graduatedMargPerc: any;

  employedPerc: any;

  selfEmpPerc: any;
  wageEmpPerc: any;

  selfEmpMalePerc: any;
  selfEmpFemalePerc: any;

  wageEmpMalePerc: any;
  wageEmpFemalePerc: any;

  stpInformation: any;
  stpMainId: any;

  dashboardDetails: any;

  validOccupations: any;
  expiredOccupations: any;
  expiringSoonOccupations: any;


  stpMainInfo$: Subscription;
  stpMainInfo: any;
  stpExpiresIn : number | null = null;
  stpExpireDate : any;
  stpExpiryStatus: StpExpiryStatus | null = null;
  isRenewalInProgress = false;
  isRenewing = false;
  stpExpiryStatus$: Subscription;
  occupationCount: any;

  constructor(private circularStorageService: CircularStorageService,
              private dashboardService: DashboardService,
              private stpRegistrationService: StpRegistrationService,
              private stpRegistrationStorageService: StpRegistrationStorageService,
            private router: Router,
            private stpExpiryService: StpExpiryService,
            private notification: NzNotificationService) {

  }

  checkComplete(userId: number): void {
    this.stpRegistrationStorageService.getlUserInfoById(userId).subscribe((rs) => {
      if (rs.success) {
        let data = rs.data;
        this.stpMainId = data?.stpMain.id;
        this.stpExpireDate = data?.stpMain.expireDate;
        this.isRenewalInProgress = data?.stpMain?.isRenewed === true;
        this.stpExpiryService.setStpMain(data?.stpMain);
        this.getDashboardDetails(this.stpMainId);
        this.getStpDashboardOccupationCount(this.stpMainId);
      }
    });
  }

  ngOnInit(): void {
    this.stpExpiryStatus$ = this.stpExpiryService.status$.subscribe((status) => {
      this.stpExpiryStatus = status;
      this.stpExpiresIn = status ? status.expiresInDays : null;
    });

    let currentUserInfo: LoginResponse = JSON.parse(localStorage.getItem('currentUserInfo') ?? '{}');

    if (currentUserInfo?.id != null) {
      this.checkComplete(currentUserInfo.id);
    };



  }

  ngOnDestroy(): void {
    this.stpExpiryStatus$?.unsubscribe();
  }

  get isStpExpired(): boolean {
    return !!this.stpExpiryStatus?.isExpired && this.stpExpiryStatus.hasRegistration;
  }

  get isStpExpiringSoon(): boolean {
    return (
      !this.stpExpiryStatus?.isExpired &&
      this.stpExpiresIn != null &&
      this.stpExpiresIn >= 0 &&
      this.stpExpiresIn <= 90 // the renewal opens 90 days before expiry
    );
  }

  // Registered and more than 90 days before expiry: the expiry date is shown as a reminder
  get isStpValid(): boolean {
    return (
      !!this.stpExpireDate &&
      !this.stpExpiryStatus?.isExpired &&
      this.stpExpiresIn != null &&
      this.stpExpiresIn > 90
    );
  }

  getDashboardDetails(stpMainId: any) {
    this.dashboardService.getStpDashboardDetails(stpMainId).subscribe({
      next: (res: any) => {
        this.dashboardDetails = res.data;
        this.enrolledMalePerc = this.percentageCal(this.dashboardDetails?.enrMale, this.dashboardDetails?.enrTolalTrainees);
        this.enrolledFemalePerc = this.percentageCal(this.dashboardDetails?.enrFemale, this.dashboardDetails?.enrTolalTrainees);
        this.enrolledOthersPerc = this.percentageCal(this.dashboardDetails?.enrOthers, this.dashboardDetails?.enrTolalTrainees);
        this.enrolledOthersPerc = this.percentageCal(this.dashboardDetails?.enrOthers, this.dashboardDetails?.enrTolalTrainees);
        this.enrolledPwdPerc = this.percentageCal(this.dashboardDetails?.enrPwd, this.dashboardDetails?.enrTolalTrainees);
        this.enrolledMargPerc = this.percentageCal(this.dashboardDetails?.enrMarginalized, this.dashboardDetails?.enrTolalTrainees);

        this.graduateddPerc = this.percentageCal(this.dashboardDetails?.grdTolalTrainees, this.dashboardDetails?.enrTolalTrainees);
        this.graduatedMalePerc = this.percentageCal(this.dashboardDetails?.grdMale, this.dashboardDetails?.grdTolalTrainees);
        this.graduatedFemalePerc = this.percentageCal(this.dashboardDetails?.grdFemale, this.dashboardDetails?.grdTolalTrainees);
        this.graduatedOthersPerc = this.percentageCal(this.dashboardDetails?.grdOthers, this.dashboardDetails?.grdTolalTrainees);
        this.graduatedPwdPerc = this.percentageCal(this.dashboardDetails?.grdPwd, this.dashboardDetails?.grdTolalTrainees);
        this.graduatedMargPerc = this.percentageCal(this.dashboardDetails?.grdMarginalized, this.dashboardDetails?.grdTolalTrainees);

        this.employedPerc = this.percentageCal((this.dashboardDetails?.selfEmpTotal + this.dashboardDetails?.wageEmpTotal), this.dashboardDetails?.grdTolalTrainees);

        this.selfEmpPerc = this.percentageCal(this.dashboardDetails?.selfEmpTotal, (this.dashboardDetails?.selfEmpTotal + this.dashboardDetails?.wageEmpTotal));
        this.wageEmpPerc = this.percentageCal(this.dashboardDetails?.wageEmpTotal, (this.dashboardDetails?.selfEmpTotal + this.dashboardDetails?.wageEmpTotal));


        this.selfEmpMalePerc = this.percentageCal(this.dashboardDetails?.selfEmpMale, this.dashboardDetails?.selfEmpTotal);
        this.selfEmpFemalePerc = this.percentageCal(this.dashboardDetails?.selfEmpFemale, this.dashboardDetails?.selfEmpTotal);
        this.selfEmpFemalePerc = this.percentageCal(this.dashboardDetails?.selfEmpFemale, this.dashboardDetails?.selfEmpTotal);


        this.wageEmpMalePerc = this.percentageCal(this.dashboardDetails?.wageEmpMale, this.dashboardDetails?.wageEmpTotal);
        this.wageEmpFemalePerc = this.percentageCal(this.dashboardDetails?.wageEmpFemale, this.dashboardDetails?.wageEmpTotal);

        this.validOccupations = this.dashboardDetails?.validOccupations;
        this.expiredOccupations = this.dashboardDetails?.expiredOccupations;
        this.expiringSoonOccupations = this.dashboardDetails?.expiringSoonOccupations;
        // if (res.data == null) {
        //   this.emailAlreadyExist = false;
        //   this.jobSeekerRegistrationForm.get('email')?.setErrors(null);
        // } else {
        //   this.emailAlreadyExist = true;
        //   this.jobSeekerRegistrationForm.get('email')?.setErrors({emailTaken: true});
        // }
      }
    });
  }


  private percentageCal(count: any, total: any): string {
    // The API sends null when there is nothing to count (e.g. no graduates yet);
    // a missing count is 0, a missing or zero total has no percentage.
    const countValue = count == null || count === '' ? 0 : Number(count);
    const totalValue = total == null || total === '' ? 0 : Number(total);
    if (!isFinite(countValue) || !isFinite(totalValue) || totalValue === 0) {
      return 'N/A';
    }

    let perc: number = (countValue / totalValue) * 100;  // Ensure it's a number
    return perc.toFixed(2) + '%';  // Convert to string with '%' symbol
  }

  getStpDashboardOccupationCount(stpMainId: any) {
    this.dashboardService.getStpDashboardOccupationCount(stpMainId).subscribe({
      next: (res: any) => {
        this.occupationCount = res;
        console.log('--------------------->', this.occupationCount);
      },
    });
  }

  // Starts the renewal directly (same API as the Renew button on the STP application list).
  startRenewal(): void {
    if (!this.stpMainId || this.isRenewing) {
      return;
    }
    this.isRenewing = true;
    this.stpRegistrationStorageService.renewStpApplication(this.stpMainId).subscribe({
      next: (response) => {
        this.isRenewing = false;
        if (response?.success) {
          this.notification.success('Success!', 'Renewal application started. Please review and submit it.');
          this.openRenewalApplication();
        } else {
          this.notification.error('Error!', response?.message || 'Could not start the renewal application.');
        }
      },
      error: (error) => {
        this.isRenewing = false;
        this.notification.error('Failed', error?.error?.message || 'Could not start the renewal application.');
      },
    });
  }

  openRenewalApplication(): void {
    this.router.navigate(['home/stp-registration/renew-reapply-dash-board']);
  }

  redirectToApplication(): void {
    // this.router.navigate([
    //   'home/stp-registration/stp-application-view/',
    //   this.stpMainId,
    // ]);
     this.router.navigate([
      'home/stp-registration/application-list-stp'
    ]);
  }

  onProjectClick(): void {
    this.router.navigate(['home/stp-operations/project/project-list']);
  }

  onCourseClick(): void {
    this.router.navigate(['home/stp-operations/course/course-list']);
  }

  onBatchClick(): void {
    this.router.navigate(['home/stp-operations/batch/batch-list']);
  }

  onTrainerClick(): void {
    this.router.navigate(['home/stp-operations/trainer/trainer-list']);
  }

  onExpiringSoonClick(): void {
    this.router.navigate([
      'home/stp-operations/approved-occupation/approved-occupation-list',
    ]);
  }

  onExpiredOccupationsClick(): void {
    this.router.navigate(['home/stp-operations/expired-occupation-list']);
  }
}
